import { __ } from '~/locale';

export const epicCountPermissionText = __('Counts reflect children you may not have access to.');
